import { render } from "./3dSecure.vue?vue&type=template&id=9e5eb8a0&scoped=true&ts=true"
import script from "./3dSecure.vue?vue&type=script&lang=ts"
export * from "./3dSecure.vue?vue&type=script&lang=ts"

import "./3dSecure.vue?vue&type=style&index=0&id=9e5eb8a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e5eb8a0"]])

export default __exports__